import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import App from './components/App';
import LogIn from './components/LogIn';

const routes = (
    <BrowserRouter>
        <Switch>
            <Route path="/log-in" exact={true} component={LogIn} />
            <Route path="/" component={App} />
        </Switch>
    </BrowserRouter>
)

ReactDOM.render(routes, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
